export default __webpack_public_path__ + "static/media/Duct.add76ea4.gif";